import React, { useEffect, useRef, useState } from 'react';
import s from './BottomSheetListing.module.scss';
import Modal from 'ui-v2/components/Modal';
import { LayoutPropType } from 'src/modules/parkplusStoreV2/types/layout';
import ShimmerImage from 'core-lib/components/ShimmerImage';
import { useComponentInViewport } from 'core-lib/hooks/useComponentInViewport';
import useStoreItemClick from 'src/modules/parkplusStoreV2/hooks/useStoreItemClick';
import { trackSectionViewedStoreV2 } from 'src/modules/parkplusStoreV2/utils/events';
import { Typography } from 'ui-v2/components/Typography';
import { Button } from 'ui-v2/components/Button';
import formatCurrency from 'core-lib/utils/currency';
import AnimatedImage from 'core-lib/components/AnimatedImage';
import { trackCtaClicked } from 'shop/constants/events';

const BottomSheetListing = ({ data, index }: LayoutPropType) => {
  const [showModal, setShowModal] = useState(false);
  const rootRef = useRef();

  const { handleItemClickWithDelegation } = useStoreItemClick();
  const CARDID = data.layoutType;

  useEffect(() => {
    const hasShownBottomSheet = sessionStorage.getItem('hasShownBottomSheet');
    if (!hasShownBottomSheet) {
      trackSectionViewedStoreV2(data?.title, {
        position: index,
        section: data?.sectionName,
      });
      const timer = setTimeout(() => {
        setShowModal(true);
        sessionStorage.setItem('hasShownBottomSheet', 'true');
      }, 1500);

      return () => clearTimeout(timer); // Cleanup on unmount
    }
  }, []);

  const handleClick = (e) => {
    handleItemClickWithDelegation(
      e,
      CARDID,
      data?.entityType,
      data?.data,
      data?.sectionName
    );
  };

  return (
    <Modal
      show={showModal}
      closeOnClickOutside
      head={{
        show: true,
        appBarData: {
          bgColor: 'primary_alpha',
        },
        onClose: () => {
          trackCtaClicked({
            option: 'close',
            section: data?.sectionName,
          });
          setShowModal(false);
        },
      }}
      variant="bottomSheet"
      rootStyle={{
        zIndex: 12,
      }}
      customeBodyStyle={{
        background: `linear-gradient(1deg, rgba(2,0,36,1) 0%, rgba(85,9,171,0.8169642857142857) 42%, rgba(35,15,57,0) 97%)`,
      }}
      blurredBg
    >
      <div className={s.root} ref={rootRef}>
        {data?.data?.map((item, i) => (
          <div key={item?.productId} className={s.overallContent}>
            <AnimatedImage
              src={item?.brandLogo}
              className={s.brandImage}
              loading="eager"
            />
            <div className={s.content}>
              <div className={s.carIcon}>
                <AnimatedImage
                  src={item?.coverImage}
                  className={s.carIconImage}
                  loading="eager"
                  alt="icon"
                />
              </div>
              <div className={s.textContent}>
                <Typography
                  label={item?.title || ' '}
                  variant="label_1_semi_bold"
                  color="on_dark_bg"
                />
                <div className={s.upperText}>
                  <Typography
                    label={item?.subtitle1}
                    variant="label_1_bold"
                    color="on_dark_bg"
                  />
                  {/* <Typography
                    label={formatCurrency(item?.price) || ' '}
                    variant="label_1_regular"
                    color="on_dark_bg"
                    className={s.lineThrough}
                  /> */}
                </div>
                <div className={s.lowerText}>
                  <Typography
                    label={'Offer auto applied on cart!'}
                    variant="label_3_regular"
                    color="on_dark_bg"
                  />
                </div>
              </div>
            </div>
            <Button
              fullWidth
              variant="primary"
              size="medium"
              label="Shop Now"
              id={CARDID}
              data-index={i}
              onClick={handleClick}
            />
          </div>
        ))}
      </div>
    </Modal>
  );
};

export default BottomSheetListing;
